
import PropTypes from 'prop-types';
import ReactApexChart from 'react-apexcharts';

// @mui
import {
  Card,
  CardHeader,
  Box,
  useMediaQuery,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';

// components
import { useChart } from '../../../components/chart';

AppWebsiteVisits.propTypes = {
  title: PropTypes.string,
  subheader: PropTypes.string,
  chartData: PropTypes.array.isRequired,
  chartLabels: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default function AppWebsiteVisits({
  title,
  subheader,
  chartLabels,
  chartData,
  ...other
}) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const chartOptions = useChart({
    plotOptions: {
      bar: {
        columnWidth: '16%',
      },
    },
    fill: {
      type: chartData.map((i) => i.fill),
    },
    labels: chartLabels,
    xaxis: {
      type: 'category',
      categories: chartLabels,
      tickPlacement: 'on',
      labels: {
        rotate: isMobile ? -90 : 0,
        rotateAlways: isMobile,
        hideOverlappingLabels: false,
        trim: false,
        style: {
          fontSize: isMobile ? '10px' : '12px',
        },
      },
    },
    grid: {
      padding: {
        left: 10,
        right: 25,
      },
    },
    tooltip: {
      shared: true,
      intersect: false,
      y: {
        formatter: (y) => {
          if (typeof y !== 'undefined') {
            return `${y.toFixed(0)}`;
          }
          return y;
        },
      },
    },
  });

  return (
    <Card {...other}>
      <CardHeader title={title} subheader={subheader} />

      <Box
        sx={{
          p: 3,
          pb: 1,
          ...(isMobile && {
            px: 1,
          }),
        }}
        dir="ltr"
      >
        <ReactApexChart
          type="line"
          series={chartData}
          options={chartOptions}
          height={364}
        />
      </Box>
    </Card>
  );
}
